/**
 * Hex-Auswahl UI: Selection-Banner und Bestätigungs-Dialog.
 * Reine DOM-Erzeuger-Funktionen ohne Klassen-Zustand.
 */

/** Entfernt ein DOM-Element und gibt null zurück (für Nullify-Pattern). */
export function removeOverlayElement(el: HTMLElement | null): null {
  if (el) el.remove();
  return null;
}

/** Erzeugt das "Wähle ein Hex"-Banner am oberen Bildschirmrand. */
export function createSelectionBanner(
  isStart: boolean,
  onCancel: () => void,
): HTMLDivElement {
  const banner = document.createElement('div');

  Object.assign(banner.style, {
    position: 'fixed', top: '0', left: '0', right: '0',
    zIndex: '15001', padding: 'clamp(10px, 2vw, 16px)',
    background: 'linear-gradient(180deg, rgba(3,5,15,0.95), rgba(3,5,15,0.85))',
    borderBottom: '1px solid rgba(136,204,255,0.3)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: 'clamp(8px, 2vw, 16px)', fontFamily: 'monospace',
    backdropFilter: 'blur(8px)',
  });

  const label = document.createElement('span');
  label.textContent = isStart
    ? '\u{1F3AF} W\u00E4hle ein Hex als START'
    : '\u{1F3AF} W\u00E4hle ein Hex als ZIEL';
  Object.assign(label.style, {
    color: '#8cf', fontSize: 'clamp(12px, 3vw, 16px)', fontWeight: '700',
  });

  const cancelBtn = document.createElement('button');
  cancelBtn.textContent = 'Abbrechen';
  Object.assign(cancelBtn.style, {
    background: 'rgba(100,180,255,0.1)', color: '#8cf',
    border: '1px solid rgba(100,180,255,0.25)',
    fontFamily: 'monospace', cursor: 'pointer',
    fontSize: 'clamp(10px, 2.5vw, 13px)', padding: '6px 14px',
    borderRadius: '6px',
  });
  cancelBtn.addEventListener('pointerdown', (e) => {
    e.stopPropagation();
    onCancel();
  });

  banner.appendChild(label);
  banner.appendChild(cancelBtn);
  document.body.appendChild(banner);
  return banner;
}

/** Erzeugt den Hex-Bestätigungs-Dialog (zentriert). */
export function createConfirmDialog(
  q: number,
  r: number,
  onConfirm: (q: number, r: number) => void,
  onOther: () => void,
): HTMLDivElement {
  const dialog = document.createElement('div');

  Object.assign(dialog.style, {
    position: 'fixed', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)', zIndex: '15002',
    background: 'linear-gradient(180deg,rgba(8,20,45,0.97),rgba(4,12,28,0.95))',
    border: '1px solid rgba(100,180,255,0.3)', borderRadius: '10px',
    padding: 'clamp(16px, 3vw, 24px)', fontFamily: 'monospace',
    textAlign: 'center',
    boxShadow: '0 0 30px rgba(80,160,255,0.15), 0 8px 32px rgba(0,0,0,0.4)',
    backdropFilter: 'blur(8px)', minWidth: '200px',
  });

  const titleEl = document.createElement('div');
  titleEl.textContent = `\u{1F4CD} Hex (${q}, ${r})`;
  Object.assign(titleEl.style, {
    color: '#bdf', fontSize: 'clamp(13px, 3vw, 16px)',
    fontWeight: '700', marginBottom: '14px',
  });

  const btnRow = document.createElement('div');
  Object.assign(btnRow.style, { display: 'flex', gap: '10px', justifyContent: 'center' });

  const confirmBtn = document.createElement('button');
  confirmBtn.textContent = 'Best\u00E4tigen';
  Object.assign(confirmBtn.style, {
    background: 'rgba(136,204,255,0.15)', color: '#8cf',
    border: '1px solid rgba(136,204,255,0.4)',
    fontFamily: 'monospace', cursor: 'pointer', fontWeight: '700',
    fontSize: 'clamp(11px, 2.5vw, 13px)', padding: '8px 18px', borderRadius: '6px',
  });
  confirmBtn.addEventListener('pointerdown', (e) => {
    e.stopPropagation();
    onConfirm(q, r);
  });

  const otherBtn = document.createElement('button');
  otherBtn.textContent = 'Anderes w\u00E4hlen';
  Object.assign(otherBtn.style, {
    background: 'transparent', color: '#5a7a9a',
    border: '1px solid rgba(100,180,255,0.15)',
    fontFamily: 'monospace', cursor: 'pointer',
    fontSize: 'clamp(11px, 2.5vw, 13px)', padding: '8px 18px', borderRadius: '6px',
  });
  otherBtn.addEventListener('pointerdown', (e) => {
    e.stopPropagation();
    onOther();
  });

  btnRow.appendChild(confirmBtn);
  btnRow.appendChild(otherBtn);
  dialog.appendChild(titleEl);
  dialog.appendChild(btnRow);
  document.body.appendChild(dialog);
  return dialog;
}
